import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=af8e23de&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=ts"
export * from "./calendar.vue?vue&type=script&lang=ts"
import style0 from "./calendar.vue?vue&type=style&index=0&id=af8e23de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8e23de",
  null
  
)

export default component.exports